import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';
import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  completeTelegramTouch,
  createTask,
  deleteTask,
  updateTask,
  type CompleteTelegramTouchResult,
  type CreateTaskInput,
  type TaskItem,
  type UpdateTaskInput,
} from '../api/tasks.client.js';

const taskMutations = createEntityMutations<TaskItem, CreateTaskInput, UpdateTaskInput>({
  key: 'tasks',
  create: createTask,
  update: updateTask,
  remove: deleteTask,
});

export const useCreateTaskMutation = taskMutations.useCreate;
export const useUpdateTaskMutation = taskMutations.useUpdate;
export const useDeleteTaskMutation = taskMutations.useDelete;

/**
 * C3: «касание сделано» on a telegram touch task. The interaction lands on
 * the deal's contact timeline, so the contact queries are invalidated next
 * to the task ones; activities cover the status change.
 */
export function useCompleteTelegramTouchMutation() {
  const queryClient = useQueryClient();
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useMutation<CompleteTelegramTouchResult, Error, string>({
    mutationFn: (taskId) => completeTelegramTouch(taskId),
    onSuccess: () =>
      Promise.all(
        ['tasks', 'contacts', 'activities'].map((root) =>
          queryClient.invalidateQueries({ queryKey: [root, workspaceId] }),
        ),
      ),
  });
}
